<template>
  <div
    :class="[
      'frame-full-image',
      { 'frame-full-image--slider': isSlider, 'frame-full-image--featured': featured },
    ]"
  >
    <div class="frame-full-image__slider" v-if="images instanceof Array && images.length > 1">
      <arrow-slider class="frame-full-image__slider__arrow-slider" @click="nextSlider" />
      <slick ref="slick" :options="slickOptions">
        <div
          class="frame-full-image__item"
          v-for="(item, index) in images"
          :key="`${item}-${index}`"
          :style="{ background: `url(${item.url || item}) no-repeat center center` }"
        ></div>
      </slick>
    </div>

    <div
      class="frame-full-image__default"
      v-if="typeof images === 'string' || (images instanceof Array && images.length === 1)"
    >
      <div
        class="frame-full-image__item"
        :style="{ background: `url(${images[0].url || images}) no-repeat center center` }"
      ></div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import ArrowSlider from "@/assets/arrow-slider.svg";

export default {
  name: "frame-full-image",

  components: {
    Slick,
    "arrow-slider": ArrowSlider,
  },

  props: {
    images: {
      type: [Array, String],
    },
    isSlider: {
      type: Boolean,
      default: false,
    },

    featured: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        variableWidth: true,
        arrows: false,
        infinite: true,
        speed: 900,
        cssEase: "cubic-bezier(.15,.22,.6,.9)",
      },
      playerVars: {
        height: "100%",
        width: "100%",
        modestbranding: 1,
        rel: 0,
      },
    };
  },

  watch: {
    images() {
      if (this.$refs.slick) {
        this.$refs.slick.setPosition();
      }
    },
  },

  methods: {
    nextSlider() {
      this.$refs.slick.next();
    },
  },
};
</script>

<style lang="scss">
.frame-full-image {
  height: auto;
  width: 100%;
  position: relative;
  padding: 30px;

  &__default {
    padding: 40px;
  }

  &--featured {
    padding: 0 30px 0 0;
  }

  &--slider {
    padding: 0;
  }

  &__item {
    height: 43vw;
    width: 100%;
    background-position: center center !important;
    background-size: cover !important;
    max-height: 830px !important;
  }

  &__slider {
    .slick-track {
      display: flex;
      overflow: hidden;
      width: 100%;
    }

    .slick-slider {
      overflow: hidden;
      width: 90%;
      left: 10%;
      position: relative;
    }

    .slick-list {
      position: relative;
      overflow: hidden;
      width: 100%;
    }

    .slick-slide {
      width: 79vw;
      margin-left: 30px;
      overflow: hidden;
      -webkit-transform: translate3d(0, 0, 0);
      -webkit-backface-visibility: hidden;
      transition: opacity 0.3s ease-out;
    }

    .slick-slider .slick-track,
    .slick-slider .slick-list {
      -webkit-perspective: 1000px;
      perspective: 1000px;
    }

    &__arrow-slider {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 40px;
      margin: auto;
      width: 80px;
      height: 80px;
      cursor: pointer;
      transition: all 0.3s ease-out;
      opacity: 1;

      image {
        width: 80px;
        height: 80px;
      }

      &:hover {
        opacity: 0.5;
        transition: opacity 0.3s ease-in-out;
      }
    }
  }
}

@media (max-width: 1400px) {
  .frame-full-image {
    &__slider {
      &__arrow-slider {
        left: 30px;
        width: 60px;
        height: 60px;

        image {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .frame-full-image {
    padding: 15px;

    &__default {
      padding: 0 20px;
    }

    &--featured {
      padding: 0 20px 0 0;
    }

    &__slider {
      &__arrow-slider {
        left: 20px;
        width: 40px;
        height: 40px;

        image {
          width: 40px;
          height: 40px;
        }
      }
    }

    &__item {
      height: 55vw;
    }

    &__play {
      width: 40px;
      height: 60px;

      image {
        width: 40px;
        height: 60px;
      }
    }
  }
}

@media (max-width: 700px) {
  .frame-full-image {
    &__slider {
      &__arrow-slider {
        left: 10px;
        width: 40px;
        height: 40px;

        image {
          width: 40px;
          height: 40px;
        }
      }
    }

    .slick-slider {
      width: 85%;
      left: 15%;
    }

    &__play {
      width: 30px;
      height: 50px;

      image {
        width: 30px;
        height: 50px;
      }
    }
  }
}

@media (max-width: 400px) {
  .frame-full-image {
    &__slider {
      &__arrow-slider {
        left: 10px;
        width: 30px;
        height: 30px;

        image {
          width: 30px;
          height: 30px;
        }
      }
    }

    .slick-slider {
      width: 85%;
      left: 15%;
    }
  }
}
</style>
